var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { TextInput } from '../TextInput';
import { useMVVM, } from '../../../hooks/useMVVM.hook';
import helpers from './helpers';
export function MaskedNumericInput(props) {
    var _a = props.allowFormat, allowFormat = _a === void 0 ? true : _a, inputProps = __rest(props, ["allowFormat"]);
    var mapViewToModel = useCallback(function (val) {
        if (val.length === 0) {
            return undefined;
        }
        return helpers.stringToNumber(val);
    }, []);
    var mapModelToView = useCallback(function (value, lastView) {
        if (typeof value === 'undefined') {
            return '';
        }
        // left leading zeroes at input field
        if (lastView &&
            lastView[0] === '0' &&
            helpers.stringToNumber(lastView) === value) {
            return lastView;
        }
        return helpers.numberToString(value, allowFormat);
    }, [allowFormat]);
    var transformOnBlur = useCallback(function (value) {
        if (value.length > 0 && value[0] === '0') {
            // remove leading zeroes on blur
            return helpers.numberToString(helpers.stringToNumber(value), allowFormat);
        }
        return value;
    }, [allowFormat]);
    var mappedMVVMProps = useMVVM(__assign(__assign({}, inputProps), { defaultViewValue: '', mapViewToModel: mapViewToModel, mapModelToView: mapModelToView }));
    return (React.createElement(TextInput, __assign({}, inputProps, mappedMVVMProps, { transform: transformOnBlur })));
}
